import * as T_T from 'cryface';

export namespace HybridServicesAppointmentValidator {
    export function validator(val: any): string {
        const errorStack: string[] = [];
        const errorPush = (err: string) => {
            errorStack.push(err);
        };
        // if (!nullValidate(val.clientName.trim().replace(' ', ''))) {
        //     errorPush('姓名不能为空');
        // }
        // if (!isCharacter(val.clientName.trim().replace(' ', ''))) {
        //     errorPush('姓名格式有误, 不可包含数字与特殊字符。');
        // }
        if (!nullValidate(val.phone.trim())) {
            errorPush('电话不能为空');
        }
        if (!isDigit(val.phone.trim().replace('+1', '')) || val.phone.trim().length !== 12 || !isDigit(val.phone.trim().replace('+1', ''))) {
            errorPush('电话格式有误, 正确应该为10位数字号码');
        }
        if (errorStack.length <= 0) {
            return 'validated';
        } else {
            return errorStack[0];
        }
    }

    export function nullValidate(val: any): boolean {
        return T_T.simpleDetect(val);
    }

    export function isDigit(val: string) {
        return T_T.isMatchRegex(val, /^\d+$/);
    }

    export function isCharacter(val: string) {
        return T_T.isMatchRegex(val, /^[\u4e00-\u9fa5_a-zA-Z]+$/);
    }

    export function isEmail(val: string) {
        const emailText = val;
        const pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
        if (pattern.test(emailText)) {
            return true;
        } else {
            return false;
        }
    }
}
